import { BlockAccessPointDto } from '@yard/app/api'
import { FC } from 'react'
import { resolveAccessPointBarRect } from '../../helpers/block-access-point-bar.utils'
import { BayGap } from '../../helpers/yard-view.utils'
import { BlockAccessPointBar } from './BlockAccessPointBar'

interface Props {
  accessPoints: BlockAccessPointDto[]
  maxBays: number
  maxRows: number
  bayGaps?: BayGap[]
}

export const BlockAccessPointBars: FC<Props> = ({ accessPoints, maxBays, maxRows, bayGaps }) => {
  return (
    <>
      {accessPoints.map(ap => (
        <BlockAccessPointBar
          key={ap.id}
          accessPoint={ap}
          rect={resolveAccessPointBarRect(ap, { maxBays, maxRows }, bayGaps)}
        />
      ))}
    </>
  )
}
